export const LEAVING_DISCLAIMER = {
    EXIT: "You are now leaving the DUPIXIENT virtual booth", 
    MAIN_COPY: "You are being redirected to the medical inquiries page of Regeneron Pharmaceuticals Inc.", 
    CONTINUE_BUTTON: "CONTINUE", 
    BACK_BUTTON:"CANCEL"
}